import { textSize } from '@hover/blueprint-theme';
import { fromEntries } from '@hover/utilities';

var sizes = /*#__PURE__*/fromEntries( /*#__PURE__*/textSize.map(function (size) {
  return [size, {
    textStyle: "body".concat(size)
  }];
}));

export { sizes as s };
